import Status from '@modules/shared/tickets/Status.vue';

export default {
    inheritAttrs: false,
    props: {
        id: {
            type: String,
            required: true,
        },
        dateReceived: {
            type: Date,
            required: true,
        },
        type: {
            type: String,
            required: true,
        },
        coefficient: {
            type: Number,
            required: true,
        },
        stake: {
            type: Number,
            required: true,
        },
        potentialWin: {
            type: Number,
            required: false,
        },
        payoff: {
            type: Number,
            required: false,
        },
        status: {
            type: String,
            required: true,
        },
        system: {
            type: Object,
            default: null,
        }
    },
    components: {
        Status,
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/modules/tickets/components/TicketRowMixin.ts